import { IconButton, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { MoreCircleIcon } from "@/icons";
import { useTheme } from "@/contexts/theme";
import { GoMakeMenu, useMenuStyles } from "@/components";
import { useMoreCircle } from "./use-more-circle";
import { useTranslation } from "react-i18next";
import { PermissionCheck } from "@/components/CheckPermission";
import { Permissions } from "@/components/CheckPermission/enum";
import { ConvertIcon } from "@/components/icons/convert-icon";
import { EditMenuIcon } from "@/icons/shared/edit-menu";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";

const MoreMenuWidget = ({
  item,
  updatedStatus,
  onClickEdit,
  editPermission = Permissions.EDIT_CLIENT,
}: any) => {
  const { primaryColor } = useGomakeTheme();
  const isModern = useTheme().currentTheme === "modern";
  const { triggerButtonSx, menuRowStyle, rowTextStyle } = useMenuStyles();
  const { t } = useTranslation();
  const { open, anchorEl, handleClose, handleClick, updatedCustomerStatus } =
    useMoreCircle({
      updatedStatus,
    });

  const handleEditClick = async () => {
    onClickEdit(item.id);
  };

  return (
    <>
      <PermissionCheck userPermission={editPermission}>
        <IconButton
          className={isModern ? "gm-quote-more-btn gm-sku-more-btn" : undefined}
          onClick={handleClick}
          sx={isModern ? undefined : [triggerButtonSx]}
        >
          {isModern ? (
            <MoreVertIcon />
          ) : (
            <MoreCircleIcon color={primaryColor(300)} />
          )}
        </IconButton>
        <GoMakeMenu
          handleClose={handleClose}
          open={open}
          anchorEl={anchorEl}
          PaperProps={isModern ? { className: "gm-quote-more-menu" } : undefined}
        >
          <MenuItem onClick={handleEditClick} style={menuRowStyle}>
            <EditMenuIcon />
            <div style={rowTextStyle}>{t("remainWords.editing")}</div>
          </MenuItem>
          <MenuItem
            onClick={() => updatedCustomerStatus(item)}
            style={menuRowStyle}
          >
            <ConvertIcon color={primaryColor(300)} />
            <div style={rowTextStyle}>
              {item?.isActive
                ? t("remainWords.convertToInactive")
                : t("remainWords.convertToActive")}
            </div>
          </MenuItem>
        </GoMakeMenu>
      </PermissionCheck>
    </>
  );
};
export { MoreMenuWidget };
